// disabled rule because it cases odd behaviour with challengers fetching << //TODO: fix
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState, useRef } from 'react';
import { shareOutline } from 'ionicons/icons';
import { IonContent, isPlatform, IonIcon } from '@ionic/react';
// import { Keyboard } from '@capacitor/keyboard';
import burgerIcon from '../../../assets/foodfight_burger.png';
import glovesIcon from '../../../assets/foodfight_gloves.png';
import logoIcon from '../../../assets/foodfight_red_primary_05_downsized.png';
import magnifyingGlass from '../../../assets/icons/magnifying-glass-solid.svg';
import MatchmakingContext from '../../../global/MatchmakingContext';
import { getFinishedBets } from '../../../global/request/bet';
// import { queryUsers, getProfile, getFriendsProfile } from '../../../global/request/user';
import { queryUsers } from '../../../global/request/user';
import useProfile from '../../../global/useProfile';
import useUsers from '../../../global/useUsers';
import { AuthContext } from '../../authentication/AuthContext';
import ModalHeader from '../ModalHeader';
import { StartFightContext, ACTIONS } from '../StartFightContext';
import useCanGo from '../useCanGo';
import FighterModalNew from './ChallengerModals/FighterModalNew';
import MatchmakingModalNew from './ChallengerModals/MatchmakingModalNew';
import ReferralModalNew from './ChallengerModals/ReferralModalNew';
import PaginatedUsers from './PaginatedUsers';

import '../../../styles/fight/challenger/PickChallenger.scss';

function PickChallenger({ pageIndex }) {
  const startFightCtx = useContext(StartFightContext);
  const matchmakingCtx = useContext(MatchmakingContext);
  // const { dispatch } = useContext(MatchmakingContext);
  const authCtx = useContext(AuthContext);
  const { idToken: bearerToken } = authCtx.tokens;
  useCanGo(pageIndex, () => startFightCtx.challenger?.id !== undefined, [startFightCtx.challenger]);

  // const submodalRef = useRef();
  // I think footerNav and matchModalRef can be removed entirely in a refactor
  // eslint-disable-next-line no-unused-vars
  const { footerNav, matchModalRef, referModalRef } = useContext(StartFightContext);

  const [searchName, setSearchName] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [loadQuery, fetchMoreFighters, fighters, isFightersLoading, isLastFightersPageLoaded] = useUsers();
  const [topRivalFighters, setTopRivalFighters] = useState([]);
  const [isMatchCheckboxChecked, setIsMatchCheckboxChecked] = useState(false);
  const [isReferCheckboxChecked, setIsReferCheckboxChecked] = useState(false);
  const [challengerModalIcon, setChallengerModalIcon] = useState();
  const [isNewFighterModalOpen, setIsNewFighterModalOpen] = useState(false);
  const [isNewMatchmakingModalOpen, setIsNewMatchmakingModalOpen] = useState(false);
  const [isNewReferModalOpen, setIsNewReferModalOpen] = useState(false);
  const [finishedBets, setFinishedBets] = useState([]);
  const [staticHeight, setStaticHeight] = useState();
  // eslint-disable-next-line no-unused-vars
  const [reload, profileData] = useProfile();
  const contentRef = useRef();

  const [originalFighters, setOriginalFighters] = useState([]);

  const [selectedFighter, setSelectedFighter] = useState(null);

  const icons = [burgerIcon, logoIcon, glovesIcon];
  const getSearchListIcon = index => {
    return icons[index % icons.length];
  };

  useEffect(() => {
    if (fighters.length && originalFighters.length === 0) {
      setOriginalFighters(fighters); // Save the first set of fighters
    }
  }, [fighters]);

  const newFaceFighters = originalFighters.filter(fighter => fighter.id !== authCtx.idData['cognito:username']);

  const findFighterId = fighterName => {
    const fighter = fighters.find(f => f.name === fighterName);
    const fighterId = fighter ? fighter.id : null;
    return fighterId;
  };

  useEffect(() => {
    if (matchmakingCtx.state.challenger) {
      if (matchmakingCtx.state.challenger.id) {
        startFightCtx.dispatch({
          action: ACTIONS.SET_CHALLENGER,
          challenger: matchmakingCtx.state.challenger,
        });
      } else if (matchmakingCtx.state.challenger.name) {
        const figherId = findFighterId(matchmakingCtx.state.challenger.name);
        startFightCtx.dispatch({
          action: ACTIONS.SET_CHALLENGER,
          challenger: {
            id: figherId,
            name: matchmakingCtx.state.challenger.name,
          },
        });
      }
    }
  }, [fighters]);

  // ios keyboard behavior workaround
  useEffect(() => {
    if (isPlatform('ios') && contentRef.current && fighters.length) {
      const currHeight = contentRef.current.clientHeight;
      setStaticHeight(currHeight);
    }
  }, [contentRef.current, fighters]);

  const handleGetMatchedClick = () => {
    setIsMatchCheckboxChecked(!isMatchCheckboxChecked);
    startFightCtx.dispatch({
      action: ACTIONS.SET_MATCHED_CLICKED,
      payload: !isMatchCheckboxChecked,
    });
    if (startFightCtx.challenger?.id === 'match') {
      startFightCtx.dispatch({
        action: 'clearChallenger',
      });
    } else {
      startFightCtx.dispatch({
        action: 'setChallenger',
        challenger: {
          id: 'match',
          name: 'Random Fighter',
        },
      });
      setIsNewMatchmakingModalOpen(true);
    }
  };

  const handleGetReferClick = () => {
    setIsReferCheckboxChecked(!isReferCheckboxChecked);
    startFightCtx.dispatch({
      action: ACTIONS.SET_REFER_CLICKED,
      payload: !isReferCheckboxChecked,
    });
    if (startFightCtx.challenger?.id === 'match') {
      startFightCtx.dispatch({
        action: 'clearChallenger',
      });
    } else {
      startFightCtx.dispatch({
        action: 'setChallenger',
        challenger: {
          id: 'match',
          name: 'New Referal Fighter',
        },
      });
      setIsNewReferModalOpen(true);
    }
  };

  async function fetchFinishedBets() {
    try {
      const bets = await getFinishedBets(bearerToken);

      const sortedBets = bets.sort((a, b) => b.timestamp - a.timestamp);

      setFinishedBets(sortedBets);
    } catch (error) {
      console.error('Error loading finished bets:', error);
    }
  }

  useEffect(() => {
    fetchFinishedBets();
  }, [authCtx.tokens]);

  useEffect(() => {
    loadQuery('~');
  }, []);

  useEffect(() => {
    if (searchName !== '') {
      loadQuery(searchName);
    }
  }, [searchName]);

  // eslint-disable-next-line no-unused-vars
  const getTopRivals = () => {
    const rivals = {
      foodfighttroy: 0,
      foodfight_fil: 0,
    };

    finishedBets.forEach(bet => {
      const { makerName, takerName } = bet;
      let fighterName;
      if (makerName === profileData?.name) {
        fighterName = takerName;
      } else {
        fighterName = makerName;
      }
      if (rivals[fighterName]) {
        rivals[fighterName] += 1;
      } else {
        rivals[fighterName] = 1;
      }
    });

    const rivalsArray = Object.entries(rivals);
    const sortedRivals = rivalsArray.sort((a, b) => b[1] - a[1]);
    const topFiveRivals = sortedRivals.slice(0, 5);
    return topFiveRivals;
  };

  useEffect(() => {
    (async () => {
      const topRivals = getTopRivals();
      // queryUsers returns a list of users who match at least one of the given queries
      const rivalFighters = await queryUsers(
        bearerToken,
        topRivals.map(rival => rival[0]),
        1,
        5,
      );
      const sortedRivals = rivalFighters.sort((a, b) => {
        const countA = topRivals.find(rival => rival[0] === a.name || rival[0] === a.username)?.[1] || 0;
        const countB = topRivals.find(rival => rival[0] === b.name || rival[0] === b.username)?.[1] || 0;
        return countB - countA;
      });
      setTopRivalFighters(sortedRivals);
      // try {
      //   // Get the user's profile to access their friends list
      //   const userProfile = await getProfile(bearerToken);
      //   // Get each friend's profile using getFriendsProfile
      //   const friendProfiles = await Promise.all(
      //     userProfile.friends.map(friendId => getFriendsProfile(bearerToken, friendId)),
      //   );
      //   setTopRivalFighters(friendProfiles);
      // } catch (error) {
      //   console.error('Error loading friends:', error);
      //   setTopRivalFighters([]);
      // }
    })();
  }, []);

  const handleDispatchToGo = (fighter, selectedIcon) => {
    startFightCtx.dispatch({
      action: 'setChallenger',
      challenger: { id: fighter.id, name: fighter.name },
    });
    startFightCtx.dispatch({
      action: 'setCanGo',
      index: startFightCtx.pageIndex,
      canGo: true,
    });
    setSelectedFighter(fighter);
    console.log('selectedIcon', selectedIcon);
    setChallengerModalIcon(selectedIcon);
    setIsNewFighterModalOpen(true);
    setIsMatchCheckboxChecked(false);
  };

  const handleCloseModal = () => {
    setIsNewFighterModalOpen(false);
    setSelectedFighter(null);
    startFightCtx.dispatch({
      action: 'clearChallenger',
      canGo: false,
    });
    setSearchName('');
  };

  const filteredNewFaces = newFaceFighters.filter(fighter => !topRivalFighters.some(rival => rival.id === fighter.id));

  return (
    <>
      <ModalHeader pageName='Pick Challenger' />
      <IonContent className='pick-challenger-modal-page' scrollY='true'>
        <div
          className='pick-challenger-container'
          ref={contentRef}
          style={{ height: staticHeight ? `${staticHeight}px` : undefined }}>
          <div className='search-bar-container'>
            <div className='search-share-bar'>
              <div className='search-bar'>
                <div className='search-icon-wrap'>
                  <img className='search-magnifying-glass' src={magnifyingGlass} alt='search' />
                </div>
                <input
                  className='search-bar-input'
                  type='text'
                  placeholder='Search FoodFighters'
                  value={searchName}
                  onChange={event => setSearchName(event.target.value)}
                />
              </div>

              {searchName && (
                <div className='search-dropdown'>
                  {/* Render the button
                  s for each fighter */}
                  {fighters.map((fighter, index) => {
                    const [firstName, lastName] = fighter.name.split(' ');
                    const shortName = lastName ? `${firstName} ${lastName[0]}` : firstName;
                    const searchListIcon = getSearchListIcon(index);

                    return (
                      <button
                        className='search-item'
                        type='submit'
                        key={fighter.id}
                        onClick={e => {
                          handleDispatchToGo(fighter);
                          e.preventDefault();
                        }}>
                        <img src={searchListIcon} alt='icon' className='search-icon-opponent-modal' />
                        {shortName}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
            <div className='share-buttons-container'>
              <button type='submit' className='post-to-public-btn' onClick={handleGetMatchedClick}>
                Post to Public
              </button>
              <button type='submit' className='refer-a-friend-btn' onClick={handleGetReferClick}>
                <IonIcon icon={shareOutline} className='share-icon' />
                Share
              </button>
            </div>
          </div>

          <div className='challenger-option-container'>
            <PaginatedUsers
              heading='TOP RIVALS'
              isLoading={isFightersLoading}
              loadedFighters={topRivalFighters}
              selectedFightId={startFightCtx.challenger?.id}
              onSelect={handleDispatchToGo}
            />
            <PaginatedUsers
              heading='NEW FACES'
              isLoading={isFightersLoading}
              loadedFighters={filteredNewFaces
                .filter(fighter => fighter.id !== authCtx.idData['cognito:username'])
                .sort(() => Math.random() - 0.5)}
              selectedFightId={startFightCtx.challenger?.id}
              onSelect={handleDispatchToGo}
            />
          </div>
        </div>
      </IonContent>
      <FighterModalNew
        isOpen={isNewFighterModalOpen}
        onClose={handleCloseModal}
        selectedIcon={challengerModalIcon}
        fighterName={selectedFighter?.name || ''}
        fighterUsername={selectedFighter?.username || ''}
      />
      <MatchmakingModalNew
        isOpen={isNewMatchmakingModalOpen}
        onClose={() => {
          setIsNewMatchmakingModalOpen(false);
          setIsMatchCheckboxChecked(!isMatchCheckboxChecked);
          startFightCtx.dispatch({
            action: ACTIONS.SET_MATCHED_CLICKED,
            payload: !isMatchCheckboxChecked,
          });
          startFightCtx.dispatch({
            action: 'clearChallenger',
            canGo: false,
          });
        }}
      />
      <ReferralModalNew
        isOpen={isNewReferModalOpen}
        onClose={() => {
          setIsNewReferModalOpen(false);
          setIsReferCheckboxChecked(!isReferCheckboxChecked);
          startFightCtx.dispatch({
            action: ACTIONS.SET_REFER_CLICKED,
            payload: !isMatchCheckboxChecked,
          });
          startFightCtx.dispatch({
            action: 'clearChallenger',
            canGo: false,
          });
        }}
      />
    </>
  );
}

export default PickChallenger;
